import { Endpoint, Graph, Api } from '@square/ignition';
import {
  ApiExplorerContextProvider,
  useApiExplorerContext,
} from '@squareup/dex-ui-shared-api-explorer-providers';
import React, { FC, PropsWithChildren, useMemo } from 'react';

interface Props {
  graph: Graph;
  endpoint: Endpoint | undefined;
  api: Api | undefined;
}

const ApiExplorerOasContainer: FC<PropsWithChildren<Props>> = ({
  children,
  graph,
  endpoint,
  api,
}) => {
  const contextValue = useApiExplorerContext();

  const memoizedContext = useMemo(() => {
    return {
      ...contextValue,
      graph,
      ...(endpoint ? { endpoint } : {}),
      ...(api ? { api } : {}),
    };
  }, [contextValue, endpoint, graph, api]);

  return (
    <ApiExplorerContextProvider value={memoizedContext}>
      {children}
    </ApiExplorerContextProvider>
  );
};

export { ApiExplorerOasContainer };
